import { getEnv, types, flow, Instance } from "mobx-state-tree";

import { StorageModel } from "../storage/StorageModel";
import { endpoints } from "../api/ApiEndpoints";
import { UserProfileEditInput } from "../../api-models/request/UserInput";
import { UserProfileDetailsResponse } from "../../api-models/response/UserDetailsResponse";
import { getImageFormData } from "../form/FormAppenders";
import { ImageWithPreview } from "../../components/image-upload/ImageUpload";
import { currentUserService } from "./CurrentUserStorage";

export const noUserProfileData: UserProfileDetailsResponse = {
  id: 0,
  firstName: "",
  lastName: "",
  userName: "",
  email: "",
  phone: "",
  registrationDate: new Date(),
  isSupportAccount: false
};

const CurrentUserModel = types.model({
  currentUser: types.optional(types.frozen<UserProfileDetailsResponse>(), noUserProfileData),
});

export const CurrentUserProfileStorageModel = types
  .compose(CurrentUserModel, StorageModel)
  .named("CurrentUserProfileStorrageModel")
  .actions((self) => {
    return {
      setPhoneAsEmptyString() {
        self.currentUser = { ...self.currentUser, phone: "" };
      },
    };
  })
  .actions((self) => {
    return {
      mapResponse(response: UserProfileDetailsResponse) {
        self.currentUser = response || noUserProfileData;
        if (!self.currentUser.phone) self.setPhoneAsEmptyString();
      },
      editMyUserProfileDetails: flow(function* editMyUserProfileDetails(
        user: UserProfileEditInput
      ) {
        const endpoint = endpoints.get("user_profile");
        const result = yield getEnv(self).api.put(endpoint, user);
        yield currentUserService.load();
        return result;
      }),
      editMyUserProfileImage: flow(function* editMyUserProfileImage(image: ImageWithPreview) {
        const imageForm = getImageFormData(image);
        const endpoint = endpoints.get("user_image");
        endpoint.routeParams = [self.currentUser.id];

        return yield getEnv(self).api.put(endpoint, imageForm);
      }),
      deleteMyUserProfileImage: flow(function* deleteMyUserProfileImage() {
        const endpoint = endpoints.get("user_image");
        endpoint.routeParams = [self.currentUser.id];

        return yield getEnv(self).api.delete(endpoint);
      }),
    };
  })
  .views((self) => ({
    get userIsLoaded() {
      return !!self.currentUser.id;
    },
    get endpoint() {
      const endpoint = endpoints.get("user_profile");
      return endpoint;
    },
  }))
  .views((self) => ({
    get isLoading() {
      return !self.userIsLoaded;
    },
  }));

export type CurrentUserProfileStorage = Instance<typeof CurrentUserProfileStorageModel>;
